<template>
  <v-container fluid>
    <template v-if="arrayParametros.length > 0">
      <v-row v-for="param in arrayParametros" :key="param.nombre">
        <v-col cols="12" md="6" class="d-flex px-1 pt-3 pb-2 align-center" :class="colorFondo(param)">
            <v-checkbox
              v-if="param.estado_parametro != 2"
              dense
              hide-details
              v-model="param.activo"
            />
            <div v-else style="width: 32px"></div>

            <!-- caja de texto (sólo numeros) -->
            <v-text-field
              v-if="param.tipo_valor == 1"
              dense
              hide-details
              :label="param.titulo"
              v-model="param.valor"
              v-inputfilter="{ expresionRegular: ['[^0-9]', 'g'], longitudMaxima: 6 }"
              @input="establecerParametroActivo (param)"
            />
            <!-- caja de texto -->
            <v-text-field
              v-if="param.tipo_valor == 4"
              dense
              hide-details
              :label="param.titulo"
              v-model="param.valor"
              @input="establecerParametroActivo (param)"
            />
            <!-- fecha -->
            <div
              class="d-block mb-n4"
              v-if="param.tipo_valor == 5"
            >
              <div class="mt-n3" style="font-size: 0.75rem">{{ param.titulo }}</div>
              <SelectorFechaHora
                class="mt-n2"
                dense
                hide-details
                :hora="false"
                formato-modelo="ISO8601"
                v-model="param.valor"
              />
            </div>
            <!-- si / no -->
            <v-switch
              v-if="param.tipo_valor == 6"
              class="my-0"
              hide-details
              v-model="param.valor"
              :label="param.titulo"
              @change="establecerParametroActivo (param)"
            />
            <!-- combo box  -->
            <v-combobox
              v-if="param.tipo_valor == 7"
              dense
              hide-details
              :label="param.titulo"
              v-model="param.valor"
              :items="param.dominio_valores__VT"
              return-object
              @input="establecerParametroActivo (param)"
            />
            <!-- fecha / hora  -->
            <div
              class="d-block mb-n4"
              v-if="param.tipo_valor == 8"
            >
              <div class="mt-n3" style="font-size: 0.75rem">{{ param.titulo }}</div>
              <SelectorFechaHora
                class="mt-n2"
                dense
                hide-details
                formato-modelo="ISO8601"
                v-model="param.valor"
                @change="establecerParametroActivo (param)"
              />
            </div>
            <!-- check box -->
            <div
              class="d-block mt-2"
              v-if="param.tipo_valor == 9"
              @click="conmutarParametroActivo (param)"
            >
              {{ param.titulo }}
            </div>

            <!-- {{ param }} -->
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col cols="12" md="6" class="d-flex px-1 pt-3 pb-2 align-center">
          <span style="font-style: italic">El informe no admite parámetros.</span>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import SelectorFechaHora from '@/components/SelectorFechaHora.vue';

export default {
  components: {
    SelectorFechaHora,
  },
  props: {
    arrayParametros: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {};
  },
  methods: {
    colorFondo (parametro) {
      if (parametro.activo)
        return "yellow lighten-3";
      else
        return "";
    },
    establecerParametroActivo (parametro) {
      parametro.activo = true;
    },
    conmutarParametroActivo (parametro) {
      parametro.activo = !parametro.activo;
    }
  },
};
</script>

<style>
</style>